import { useEffect } from "react"

export const RestoreStoragePage = () => {
  useEffect(() => {
    const url = new URL(window.location.href);
    url.searchParams.forEach((value, key) => {
      window.localStorage.setItem(key, value);
    })
    window.location.href = '/web/home';
  }, [])
  return (
    <></>
  )
}